<section class="trial-placement-nodes-cards-container" id="nodesListContainer">
  <gen-selection-list
    [fields]="[]"
    [counter]="false"
    [listRowType]="'content'"
    [prioritizeAvailable]="false"
    [edit]="false"
    [listModel]="nodes"
    class="treatments-selection-list">
    <ng-template list-item let-item>
      <section class="trial-placement-node-card" [ngClass]="{'selected' : item.data.selected}"
               [attr.node-data-id]="item.data.nodeId" (click)="nodeCardSelected(item.data.nodeId)">
        <gen-dynamic-form
          [formName]="'PATHWAYBPMN-CLINICAL-TRIAL-NODE-CARD'"
          [formData]="item.data"
          [formVertical]="true"
          [updateOnBlur]="true"
          [editMode]="false"
          [disabled]="disabled"
          (formChange)="updateNodes($event)">
        </gen-dynamic-form>
        <gen-dynamic-form
          [formName]="'PATHWAYBPMN-CLINICAL-TRIAL-NODE-CARD-AVAILABILITY'"
          [formData]="item.data"
          [formVertical]="true"
          [editMode]="false"
          [disabled]="disabled"
          (formChange)="updateNodes($event)">
        </gen-dynamic-form>
        <div *ngIf="!disabled" class="trial-placement-node-card-remove icon__DeleteTrash"
             (click)="removeNode($event, item.data)"></div>
      </section>
    </ng-template>
  </gen-selection-list>
</section>
